<template>
  <div class="card">
    <div>
      <v-row
        no-gutters
        justify="space-between"
        class="pt-2"
      >
        <v-col
          align-self="center"
          cols="auto"
        >
          <div
            v-if="contrat.contratAgrial"
            class="px-2 mx-2 intro font-weight-bold"
            :class="couleurParEtat"
          >
            {{ contrat.libelle | capitalize }} <v-chip
              small
              label
              outlined
              :color="couleurParEtat"
            >
              {{ contrat.poidsEnTonne | roundNumber(3) }} t
            </v-chip>
          </div>
          <div
            v-else
            class="px-2 mx-2 text-h6 text-md-subtitle-2 font-weight-bold"
            :class="couleurParEtat"
          >
            {{ contrat.libelle | capitalize }}
          </div>
        </v-col>
        <v-col
          v-if="!contrat.contratAgrial"
          align-self="center"
          cols="1"
        >
          <AgrButton
            v-if="hasDroitEcriture"
            icon
            :disabled="loadingDelete"
            @click="onDelete"
          >
            <v-icon color="grey darken-2">
              mdi-trash-can-outline
            </v-icon>
          </AgrButton>
          <v-tooltip
            v-else
            bottom
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <AgrButton
                  icon
                  :disabled="loadingDelete"
                >
                  <v-icon color="grey lighten-1">
                    mdi-trash-can-outline
                  </v-icon>
                </AgrButton>
              </div>
            </template>
            <span class="texte white--text">Vous n'avez pas les autorisations</span>
          </v-tooltip>
        </v-col>
        <v-col
          v-else
          align-self="center"
          cols="1"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <img
                class="align-self-center mr-2 logo-bag"
                src="@/assets/icon-bag-ar.svg"
                v-on="on"
              >
            </template>
            Contrat Agrial
          </v-tooltip>
        </v-col>
      </v-row>
      <div
        v-if="contrat.contratAgrial"
        class="ml-4 mb-2 texte"
        :class="couleurParEtat"
      >
        Contrat N° {{ contrat.numeroContrat }} du {{ contrat.dateSouscription | date('dd/MM/yyyy') }}
      </div>
      <v-row
        :class="contrat.numeroContrat && !$vuetify.breakpoint.mobile ? '' : 'mt-6'"
        no-gutters
      >
        <v-col>
          <v-card-text class="text-subtitle-2 texte-gris-fonce py-2">
            Type de contrat
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text
            v-if="contrat.typeContrat != null"

            class="text-subtitle-2 py-2 align-end"
            :class="couleurParEtat"
          >
            {{ contrat.typeContrat.libelle | capitalize }}
          </v-card-text>
          <div
            v-else
            class="align-end py-2 pr-4 titre-h4"
            :class="couleurParEtat"
          >
            -
          </div>
        </v-col>
      </v-row>
      <v-divider class="mx-4" />
      <v-row
        no-gutters
      >
        <v-col>
          <v-card-text class="text-subtitle-2 texte-gris-fonce py-3">
            {{ contrat.contratAgrial ? 'Poids contrat affecté' : 'Poids contrat' }}
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text
            v-if="poidsContratAffecte != null"
            class="text-subtitle-2 py-2  align-end"
            :class="couleurParEtat"
          >
            {{ poidsContratAffecte | roundNumber(3) }}
            <span class="text-body-1">
              t
            </span>
          </v-card-text>
          <v-col
            v-else
            class="align-end py-2 pr-4 titre-h4"
            :class="couleurParEtat"
          >
            -
          </v-col>
        </v-col>
      </v-row>
      <v-divider class="mx-4" />
      <v-row
        no-gutters
      >
        <v-col>
          <v-card-text class="text-subtitle-2 texte-gris-fonce py-2 pl-4">
            Type de prix
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text
            v-if="contrat.typePrix != null"
            :class="contrat.typePrix.code !== 'PRIX_PAYE' && contrat.typeContrat.code !=='ECHANGE' ? '--text-orange-dark' : couleurParEtat"
            class="text-subtitle-2 py-2 align-end"
          >
            {{ contrat.typePrix.libelle | capitalize }}
          </v-card-text>
          <v-col
            v-else
            :class="contrat.typePrix.code !== 'PRIX_PAYE' && contrat.typeContrat.code !=='ECHANGE' ? '--text-orange-dark' : couleurParEtat"
            class="align-end py-2 pr-4 titre-h4"
          >
            -
          </v-col>
        </v-col>
      </v-row>
      <v-divider
        v-if="contrat.typePrix.code === 'PRIX_PAYE' || contrat.typePrix.code === 'PRIX_CONTRAT'"
        class="mx-4"
      />
      <v-row
        v-if="contrat.typePrix.code === 'PRIX_PAYE' || contrat.typePrix.code === 'PRIX_CONTRAT'"
        no-gutters
      >
        <v-col>
          <v-card-text class="text-subtitle-2 texte-gris-fonce py-3">
            {{ contrat.typePrix.code === 'PRIX_PAYE' ? 'Prix payé' : 'Prix contrat' }}
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text
            v-if="contrat.prixPayeEnEuroParTonne != null"
            :class="contrat.typePrix.code === 'PRIX_CONTRAT' ? '--text-orange-dark' : couleurParEtat"
            class="text-subtitle-2 py-2 align-end"
          >
            {{ contrat.prixPayeEnEuroParTonne | roundNumber(2) }}
            <span class="text-body-1">
              €/t
            </span>
          </v-card-text>
          <v-col
            v-else
            :class="contrat.typePrix.code === 'PRIX_CONTRAT' ? '--text-orange-dark' : couleurParEtat"
            class="align-end py-2 pr-4 titre-h4"
          >
            -
          </v-col>
        </v-col>
      </v-row>
      <v-divider
        v-if="contrat.typePrix.code === 'PRIX_PAYE' || contrat.typePrix.code === 'PRIX_CONTRAT'"
        class="mx-4"
      />
      <v-row
        v-if="contrat.typePrix.code === 'PRIX_PAYE' || contrat.typePrix.code === 'PRIX_CONTRAT'"
        no-gutters
      >
        <v-col>
          <v-card-text class="text-subtitle-2 texte-gris-fonce py-3">
            Prix provisoire
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text
            :class="contrat.isPrixProvisoire ? '--text-orange-dark' : couleurParEtat"
            class="text-subtitle-2 py-2 align-end"
          >
            {{ contrat.isPrixProvisoire === true ? 'Oui' : 'Non' }}
          </v-card-text>
        </v-col>
      </v-row>
    </div>
    <div>
      <div
        class="px-5"
      >
        <v-row
          v-if="contrat.cultures.length > 1 && isImportation"
        >
          <v-col cols="6">
            <AgrButton
              v-if="hasDroitEcriture"
              class="py-6 w-100"
              outlined
              @click="onRepartirPoids"
            >
              Répartir
            </AgrButton>
            <v-tooltip
              v-else
              bottom
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <AgrButton
                    class="py-6 w-100"
                    disabled
                    outlined
                  >
                    Répartir
                  </AgrButton>
                </div>
              </template>
              <span class="texte white--text">Vous n'avez pas les autorisations</span>
            </v-tooltip>
          </v-col>
          <v-col cols="6">
            <AgrButton
              v-if="hasDroitEcriture"
              class="py-6 w-100"
              :disabled="loadingDelete"
              @click="onConfirmerDonnees"
            >
              Confirmer
            </AgrButton>
            <v-tooltip
              v-else
              bottom
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <AgrButton
                    class="py-6 w-100"
                    disabled
                  >
                    Confirmer
                  </AgrButton>
                </div>
              </template>
              <span class="texte white--text">Vous n'avez pas les autorisations</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row
          v-else-if="isSaisieManuelle"
          class="d-flex"
        >
          <v-col cols="12">
            <AgrButton
              v-if="hasDroitEcriture"
              class="py-6 w-100"
              :disabled="loadingDelete"
              @click="onEditContrat"
            >
              Modifier
            </AgrButton>
            <v-tooltip
              v-else
              bottom
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <AgrButton
                    class="py-6 w-100"
                    disabled
                    outlined
                  >
                    Modifier
                  </AgrButton>
                </div>
              </template>
              <span class="texte white--text">Vous n'avez pas les autorisations</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div
        v-if="contrat.dateCreation !== contrat.dateModification"
        class="align-end mention texte-gris-fonce pa-2"
      >
        Modifié par {{ contrat.userModification !== contrat.numtiers ? contrat.userModification : 'l\'adhérent' }} le {{ contrat.dateModification | date('dd/MM/yyyy') }}
      </div>
      <div
        v-if="contrat.dateCreation === contrat.dateModification"
        class="align-end mention texte-gris-fonce pa-2"
      >
        Saisi par {{ contrat.userCreation !== contrat.numtiers ? contrat.userModification : 'l\'adhérent' }} le {{ contrat.dateCreation | date('dd/MM/yyyy') }}
      </div>
    </div>
  </div>
</template>

<script>
import { AgrButton } from '@agrial/ui'

export default {
  name: 'ContratRestitution',
  components: { AgrButton },
  props: {
    contrat: {
      type: Object,
      default: () => { }
    },
    codeGraineSelected: {
      type: String,
      default: null
    },
    loadingDelete: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasDroitEcriture () {
      return this.$roles.hasDroitEcritureAdminDte()
    },
    hasAnyAction () {
      return !this.contrat.hasRepartition && this.contrat.numeroContrat
    },
    poidsContratAffecte () {
      return this.codeGraineSelected!= null ?  this.contrat.contratAgrial ? this.contrat.cultures.find(c => c.typeCulture.code === this.codeGraineSelected).poidsEnTonne : this.contrat.poidsEnTonne : null
    },
    couleurParEtat () {
      let result
      if (this.poidsContratAffecte === 0) {
        result = '--text-grey-dark'
      } else {
        result = 'secondary--text'
      }
      return result
    },
    isImportation () {
      return this.contrat.typeSaisie === 'IMPORTATION'
    },
    isSaisieManuelle () {
      return this.contrat.typeSaisie === 'SAISIE_MANUELLE'
    }
  },


  methods: {
    onDelete () {
      this.$emit('supprimer', this.contrat)
    },
    onEditContrat () {
      if (this.contrat.contratAgrial) {
        this.$emit('repartirPoids', this.contrat)
      } else {
        this.$emit('modifier', this.contrat)
      }
    },
    onRepartirPoids () {
      this.$emit('repartirPoids', this.contrat)
    },
    onConfirmerDonnees () {
      this.$emit('confirmer', this.contrat)
    },
  }
}
</script>

<style lang="scss" scoped>
.align-end {
  text-align: end;
}

.align-center {
  text-align: center;
}

.w-100 {
  width: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 400px;
}
.logo-bag {
  width: 1.9em;
}

</style>
